var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "footer-container" },
    [
      _c(
        "van-collapse",
        {
          model: {
            value: _vm.activeNames,
            callback: function($$v) {
              _vm.activeNames = $$v
            },
            expression: "activeNames"
          }
        },
        [
          _c(
            "van-collapse-item",
            {
              attrs: { name: "1" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function() {
                    return [_c("div", [_vm._v(_vm._s(_vm.$t("300262")))])]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href:
                          _vm.language == "zh-TC"
                            ? "https://support.superex.com/hc/zh-hk/articles/4413122414105"
                            : _vm.language == "ko"
                            ? "https://support.superex.com/hc/ko/articles/4413122441497"
                            : "https://support.superex.com/hc/en-001/articles/4413122427545"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300263")))]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href:
                          _vm.language == "zh-TC"
                            ? "https://support.superex.com/hc/zh-hk/articles/11461213305625"
                            : _vm.language == "ko"
                            ? "https://support.superex.com/hc/ko/articles/11478725012761"
                            : "https://support.superex.com/hc/en-001/articles/11478863478809"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300264")))]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href:
                          _vm.language == "zh-TC"
                            ? "https://support.superex.com/hc/zh-hk/categories/4410470420249"
                            : _vm.language == "ko"
                            ? "https://support.superex.com/hc/ko/categories/4410470420249"
                            : "https://support.superex.com/hc/en-001/categories/4410470420249"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300265")))]
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "van-collapse-item",
            {
              attrs: { name: "2" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function() {
                    return [_c("div", [_vm._v(_vm._s(_vm.$t("300266")))])]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          _vm.language == "zh-TC"
                            ? "https://support.superex.com/hc/zh-hk/categories/4412787796889-%E6%96%B0%E6%89%8B%E4%B8%AD%E5%BF%83"
                            : _vm.language == "ko"
                            ? "https://support.superex.com/hc/ko/categories/4412787796889-%EC%B4%88%EB%B3%B4%EC%9E%90-%EC%95%84%EC%B9%B4%EB%8D%B0%EB%AF%B8"
                            : "https://support.superex.com/hc/en-001/categories/4412787796889-Beginner-s-Center",
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300267")))]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          _vm.language == "zh-TC"
                            ? "https://support.superex.com/hc/zh-hk/categories/4410478890137-%E7%8F%BE%E8%B2%A8-%E6%9D%A0%E6%9D%86%E4%BA%A4%E6%98%93"
                            : _vm.language == "ko"
                            ? "https://support.superex.com/hc/ko/categories/4410478890137-%ED%98%84%EB%AC%BC-%EB%A0%88%EB%B2%84%EB%A6%AC%EC%A7%80-%EA%B1%B0%EB%9E%98"
                            : "https://support.superex.com/hc/en-001/categories/4410478890137-Spot-Leveraged-Trading",
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300268")))]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          _vm.language == "zh-TC"
                            ? "https://support.superex.com/hc/zh-hk/categories/4410478992793-%E5%90%88%E7%B4%84%E4%BA%A4%E6%98%93"
                            : _vm.language == "ko"
                            ? "https://support.superex.com/hc/ko/categories/4410478992793-%EC%84%A0%EB%AC%BC-%EA%B1%B0%EB%9E%98"
                            : "https://support.superex.com/hc/en-001/categories/4410478992793-Futures-Trading",
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300269")))]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          _vm.language == "zh-TC"
                            ? "https://support.superex.com/hc/zh-hk/categories/4412774906905-%E5%B8%B8%E8%A6%8B%E5%95%8F%E9%A1%8C"
                            : _vm.language == "ko"
                            ? "https://support.superex.com/hc/ko/categories/4412774906905-FAQ"
                            : "https://support.superex.com/hc/en-001/categories/4412774906905-FAQ",
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300270")))]
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "van-collapse-item",
            {
              attrs: { name: "3" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function() {
                    return [_c("div", [_vm._v(_vm._s(_vm.$t("300271")))])]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/register")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300272")))]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/register")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300273")))]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          _vm.language == "zh-TC"
                            ? "https://forms.gle/im8VG33P5c8z1bie8"
                            : "https://forms.gle/ggiJhMgyz5HD8gUcA",
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300274")))]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/register")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300275")))]
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "van-collapse-item",
            {
              attrs: { name: "4" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function() {
                    return [_c("div", [_vm._v(_vm._s(_vm.$t("300276")))])]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href:
                          _vm.language == "zh-TC"
                            ? "https://support.superex.com/hc/zh-hk"
                            : _vm.language == "ko"
                            ? "https://support.superex.com/hc/ko"
                            : "https://support.superex.com/hc/en-001"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300277")))]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://support.superex.com/hc/en-001/requests/new"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300278")))]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        hhref: "mailto:business@superex.com",
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300279")))]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "mailto:gbg@superex.com",
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300280")))]
                  )
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "logo" }, [
        _c(
          "svg",
          {
            staticClass: "icon",
            attrs: { slot: "image", "aria-hidden": "true" },
            slot: "image"
          },
          [_c("use", { attrs: { "xlink:href": "#icon-logo1" } })]
        ),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("300261")))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contacts-box flex-center" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.linksObj.twitter.length != 0,
                expression: "linksObj.twitter.length != 0"
              }
            ],
            staticClass: "contact-item",
            on: {
              click: function($event) {
                return _vm.handleClick("twitter")
              }
            }
          },
          [
            _c(
              "svg",
              {
                staticClass: "icon",
                attrs: { slot: "image", "aria-hidden": "true" },
                slot: "image"
              },
              [_c("use", { attrs: { "xlink:href": "#icon-Twitter_gaoliang" } })]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.linksObj.telegram.length != 0,
                expression: "linksObj.telegram.length != 0"
              }
            ],
            staticClass: "contact-item",
            on: {
              click: function($event) {
                return _vm.handleClick("telegram")
              }
            }
          },
          [
            _c(
              "svg",
              {
                staticClass: "icon",
                attrs: { slot: "image", "aria-hidden": "true" },
                slot: "image"
              },
              [
                _c("use", {
                  attrs: { "xlink:href": "#icon-Telegram-gaoliang" }
                })
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.linksObj.medium.length != 0,
                expression: "linksObj.medium.length != 0"
              }
            ],
            staticClass: "contact-item",
            on: {
              click: function($event) {
                return _vm.handleClick("medium")
              }
            }
          },
          [
            _c(
              "svg",
              {
                staticClass: "icon",
                attrs: { slot: "image", "aria-hidden": "true" },
                slot: "image"
              },
              [_c("use", { attrs: { "xlink:href": "#icon-medium-1" } })]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.linksObj.INS.length != 0,
                expression: "linksObj.INS.length != 0"
              }
            ],
            staticClass: "contact-item",
            on: {
              click: function($event) {
                return _vm.handleClick("INS")
              }
            }
          },
          [
            _c(
              "svg",
              {
                staticClass: "icon",
                attrs: { slot: "image", "aria-hidden": "true" },
                slot: "image"
              },
              [_c("use", { attrs: { "xlink:href": "#icon-INS_gaoliang" } })]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.linksObj.Discord.length != 0,
                expression: "linksObj.Discord.length != 0"
              }
            ],
            staticClass: "contact-item",
            on: {
              click: function($event) {
                return _vm.handleClick("Discord")
              }
            }
          },
          [
            _c(
              "svg",
              {
                staticClass: "icon",
                attrs: { slot: "image", "aria-hidden": "true" },
                slot: "image"
              },
              [
                _c("use", {
                  attrs: { "xlink:href": "#icon-Discord-xuanzhong" }
                })
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.linksObj.YouTube.length != 0,
                expression: "linksObj.YouTube.length != 0"
              }
            ],
            staticClass: "contact-item",
            on: {
              click: function($event) {
                return _vm.handleClick("YouTube")
              }
            }
          },
          [
            _c(
              "svg",
              {
                staticClass: "icon",
                attrs: { slot: "image", "aria-hidden": "true" },
                slot: "image"
              },
              [_c("use", { attrs: { "xlink:href": "#icon-youtube_gaoliang" } })]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.linksObj.Facebook.length != 0,
                expression: "linksObj.Facebook.length != 0"
              }
            ],
            staticClass: "contact-item",
            on: {
              click: function($event) {
                return _vm.handleClick("Facebook")
              }
            }
          },
          [
            _c(
              "svg",
              {
                staticClass: "icon",
                attrs: { slot: "image", "aria-hidden": "true" },
                slot: "image"
              },
              [
                _c("use", {
                  attrs: { "xlink:href": "#icon-facebook-gaoliang" }
                })
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.linksObj.CMC.length != 0,
                expression: "linksObj.CMC.length != 0"
              }
            ],
            staticClass: "contact-item",
            on: {
              click: function($event) {
                return _vm.handleClick("CMC")
              }
            }
          },
          [
            _c(
              "svg",
              {
                staticClass: "icon",
                attrs: { slot: "image", "aria-hidden": "true" },
                slot: "image"
              },
              [_c("use", { attrs: { "xlink:href": "#icon-cmc_gaoliang" } })]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "copyright" }, [
        _vm._v("\n    © 2024 SUPERDAO INC\n  ")
      ]),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c("div", { staticClass: "flex-between title" }, [
            _c("span", { staticClass: "inline-block capitalize" }, [
              _vm._v(_vm._s(_vm.activeType))
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "iconfont icon-guanbi1",
              on: {
                click: function($event) {
                  _vm.show = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.resultList, function(item) {
              return _c(
                "li",
                {
                  key: item.id,
                  on: {
                    click: function($event) {
                      return _vm.goLink(item.url)
                    }
                  }
                },
                [_vm._v(_vm._s(item.title))]
              )
            }),
            0
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e449518c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e449518c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/footerView.vue
// module id = /iCx
// module chunks = 0